import React from "react";
import {Switch, Route} from "react-router-dom";

import InstagramSearch from 'components/LM/InstagramSearch/InstagramSearch';
import InstagramResults from 'components/LM/InstagramSearch/InstagramResults';

const Instagram = (props) => (
	<Switch>
    <Route path="/instagram/search/results">
			<InstagramResults {...props}></InstagramResults>
    </Route>
    <Route path="/instagram/search" exact>
			<InstagramSearch {...props}></InstagramSearch>
    </Route>
  </Switch>
)

export default Instagram;
